module.exports = __webpack_public_path__ + "static/media/dark-theme-distance.b6fa44fe.svg";